(function($) {
  $(document).ready(function() {

    // === Wrap Tables in Responsive Container ===
    $('.pillar-page-section table').each(function() {
      if (!$(this).parent().hasClass('responsive-table')) {
        $(this).wrap('<div class="responsive-table"></div>');
      }
    });

    // === Build Pillar Page Navigation ===
    var navList = $('.pillar-page--nav_list');

    if (navList.length) {
      $('.pillar-page-section').each(function() {
        var title = $(this).find('.pillar-page-section--title').text();
        var id = $(this).attr('id');
        if (title && id) {
          navList.append('<li><a href="#' + id + '">' + title + '</a></li>');
        }
      });
    }

    // === Toggle Navigation Collapse ===
    $('.pillar-page--nav_title i').on('click', function(e) {
      e.preventDefault();
      $('.pillar-page--nav_wrap').toggleClass('minimize');
      $(this).toggleClass('fa-minus fa-plus');
    });

    // === Smooth Scroll on Click ===
    $(document).on('click', '.pillar-page--nav_list a', function(e) {
      var target = $(this).attr('href');
      if (target && target.startsWith('#')) {
        e.preventDefault();

        var $targetEl = $(target);
        if ($targetEl.length) {
          var offset = $targetEl.offset().top - 100; // adjust offset as needed
          $('html, body').animate({ scrollTop: offset }, 600);

          // update active state immediately on click
          $('.pillar-page--nav_list li').removeClass('active');
          $(this).parent().addClass('active');
        }
      }
    });

    // === Activate Menu Item on Scroll ===
    var lastId;
    var topMenu = $('.pillar-page--nav');
    var menuItems = topMenu.find('a');

    var scrollItems = menuItems.map(function() {
      var href = $(this).attr('href');
      if (href && href.startsWith('#') && href.length > 1) {
        var item = $(href);
        if (item.length) return item;
      }
    });

    $(window).on('scroll', function() {
      var fromTop = $(this).scrollTop() + 250;
      var cur = scrollItems.map(function() {
        if ($(this).offset().top < fromTop) return this;
      });
      cur = cur[cur.length - 1];
      var id = cur && cur.length ? cur[0].id : '';

      if (lastId !== id) {
        lastId = id;
        var lastIdElement = $("[href='#" + id + "']");

        menuItems
          .parent()
          .removeClass('active')
          .end()
          .filter(lastIdElement)
          .parent()
          .addClass('active');
      }
    });

  });
})(jQuery);
